import styled from "styled-components"
import { device } from "breakpoints"
import { MainColumn } from "components/MainColumn"

export const InternalPageWrapper = styled(MainColumn)``

export const SubmitButton = styled.button`
  background: black;
  color: white;
  font-size: 18px;
  display: flex;
  align-items: center;
  height: 54px;
  justify-content: center;
  width: 100%;
  font-weight: 600;
  border: none;
  transition: 100ms;
  margin-top: 25px;

  :hover {
    background: #c7b8a8;
    color: black;
  }

  :focus {
    background: #c7b8a8;
    color: black;
    outline: 2px solid #ffd800;
  }

  :active {
    background: #b9a692;
    color: black;
  }

  @media ${device.desktop} {
    width: auto;
    padding: 0 25px;
    height: 46px;
    margin-top: 50px;
  }
`
